import { useHistory, useLocation } from 'react-router';
import { useCallback } from 'react';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { VisitEncounterMode } from './VisitEncounterModeField.types';
import {
   getVisitEncounterModeFilterCount,
   getVisitEncounterModesFilterSearchParamValue,
} from './VisitEncounterModeField.utils';
import { visitEncounterModeFilterStorage } from './VisitEncounterModeField.storage';

export const useVisitEncounterModeTriggerLabelExtractor = (): ((
   currentEncounterModes: VisitEncounterMode[]
) => string) => {
   const translate = useTranslate();

   return (currentEncounterModes) => {
      if (!currentEncounterModes.length) {
         return translate(appointmentsTranslationKeys.visitEncounterModeFilter.selectEncounterModes);
      }
      return translate(
         createInterpolatedTranslationKey(appointmentsTranslationKeys.visitEncounterModeFilter.chosenOf, {
            count: currentEncounterModes.length,
            totalCount: getVisitEncounterModeFilterCount(),
         })
      );
   };
};

export const useVisitEncounterModeFilterSearchParamHandler = (
   currentEncounterMode: VisitEncounterMode[]
): VoidFunction => {
   const history = useHistory();
   const location = useLocation();

   return useCallback(() => {
      const searchParams = new URLSearchParams(location.search);
      const visitEncounterModesFilterValue = getVisitEncounterModesFilterSearchParamValue(currentEncounterMode);

      if (currentEncounterMode.length) {
         searchParams.set(visitPaths.VISIT_ENCOUNTER_MODE_SEARCH_PARAM, visitEncounterModesFilterValue);
         visitEncounterModeFilterStorage.setFilter(visitEncounterModesFilterValue);
      }

      if (!currentEncounterMode.length) {
         searchParams.delete(visitPaths.VISIT_ENCOUNTER_MODE_SEARCH_PARAM);
         visitEncounterModeFilterStorage.deleteFilter();
      }

      return history.replace({ search: searchParams.toString(), state: location.state });
   }, [currentEncounterMode, history, location.search, location.state]);
};
